<template>
<div class="chapter">
<div class="inner_page">
<p class="fmhd" id="fm02-h1-001"><b><i>dedication</i></b></p>
<p class="noindent">I dedicate this book to my mother, who has been deceased for many years. She was my coach, my sewing teacher, and the person that taught me everything about sewing with different substrates. It can be tricky to sew with lots of different types of fabric, and she taught me not to be afraid to try all kinds. As a result, I love to incorporate many textures and fibers into my sewing. That is why I was so excited when plush fabrics came onto the market, along with the sumptuous double gauzes and suede. I knew I had to write a book about this topic. Thanks, Mom, for creating a courageous seamstress.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_dedication.vue?0365f66d